/**
 * Auth Vuex Store Module State
 * @property {Array} restaurants- list of restaurants objects
 */
export const state = {
  restaurants: [],
};
/**
 * Auth Vuex Store Module Getters
 * @property {list} restaurants- list of restaurants objects
 */
export const getters = {
  rests:     state => state.restaurants,
  restByKey: state => restKey =>
    state.restaurants.find(rest => rest.id === restKey),
  restaurants:                     state => state.restaurants,
  doesDeviceSupportCurbsidePickup: (_, getters) => getters.isKioskPlatform,
};

export default {
  state,
  getters,
};



// WEBPACK FOOTER //
// ./src/apps/desktop/store/state.js